export const colorsThemes =[
    "mustard",
    "green",
    "blue",
    "steelblue",
    "lavender",
    "red",
    "yellow",
    "blue",
    "mustard",
    "green",
    "blue",
    "steelblue",
    "lavender",
    "red",
    "yellow"
];
